module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leaderboard"
  }, [_c('touch', {
    on: {
      "tap": _vm.gotoRanking
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.joinedGroup),
      expression: "joinedGroup"
    }],
    staticClass: "ranking"
  }, [_c('h3', [_vm._v(_vm._s(_vm.myGroup.name))]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("第 "), _c('strong', [_vm._v(_vm._s(_vm.myGroup.ranking))]), _vm._v(" 名 · 累计捐赠 "), _c('strong', [_vm._v(_vm._s(_vm.duration2course(_vm.myGroup.duration)))]), _vm._v(" 节")]), _vm._v(" "), _c('webp-image', {
    attrs: {
      "src": _vm.myGroup.icon,
      "alt": "icon"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.joinedGroup),
      expression: "!joinedGroup"
    }],
    staticClass: "title"
  }, [_c('h4', [_vm._v("英语流利说 × 美丽中国")]), _vm._v(" "), _c('h2', [_vm._v("高校公益争霸赛")]), _vm._v(" "), _c('webp-image', {
    staticClass: "school-icon",
    attrs: {
      "src": "https://cdn.llscdn.com/fe-static/lls-with-tfchina/school-HXC4xSHf.png",
      "alt": "school"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-77e19fc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Leaderboard.vue
// module id = 208
// module chunks = 1